<!-- Zweck: Stellt die HTML-Struktur für statistics artikel einkauf view component im Frontend bereit. -->
<div #box>
  <div style="padding: 5px">
    <mat-form-field appearance="outline">
      <mat-label>Jahr</mat-label>
      <mat-select [(value)]="year" (selectionChange)="changeYear()">
        @for (y of years; track y) {
          <mat-option [value]="y">{{y}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <ngx-simplebar [options]="{autoHide: false}">
    <div style="padding-bottom: 5px">
      @if (year) {
        <statistic-artikel-einkauf [artNr]="artNr" [artName]="artName" [lcustomers]="lcustomers" [year]="year"
          [supplierStats]="supplierStats">
        </statistic-artikel-einkauf>
      }
    </div>
  </ngx-simplebar>
</div>
